import { useMemo } from 'react';
import { useIntl } from '@doxyme/locale';
import { RealtimeMemberStatus } from '../../features/realtime/realtime.types';
type TextStatus = {
  status: string;
  info: string;
  tooltip: string;
};

type TextStatusTypes = {
  available: TextStatus;
  offline: TextStatus;
  video: TextStatus;
  onhold: TextStatus;
};

export const useTextStatusDict = (): TextStatusTypes => {
  const { formatMessage } = useIntl();
  return useMemo(
    (): TextStatusTypes => ({
      [RealtimeMemberStatus.Online]: {
        status: formatMessage({ id: 'online' }),
        info: formatMessage({ id: 'onlineStatusInfo' }),
        tooltip: formatMessage({ id: 'openChat' }),
      },
      [RealtimeMemberStatus.Offline]: {
        status: formatMessage({ id: 'away' }),
        info: formatMessage({ id: 'offlineStatusInfo' }),
        tooltip: formatMessage({ id: 'offlineChatStatus' }),
      },
      [RealtimeMemberStatus.Busy]: {
        status: formatMessage({ id: 'busy' }),
        info: formatMessage({ id: 'busyStatusInfo' }),
        tooltip: formatMessage({ id: 'openChat' }),
      },
      [RealtimeMemberStatus.OnHold]: {
        status: formatMessage({ id: 'onHold' }),
        info: formatMessage({ id: 'onHoldStatusInfo' }),
        tooltip: formatMessage({ id: 'openChat' }),
      },
    }),
    [formatMessage],
  );
};
